import React from "react";
import { FormGroup, FormText, Label } from "reactstrap";
import { Input } from "@cadmakers-ui/core";
import ElementSpacer from "../../../Layout/Components/ElementSpacer";

type Props = {
  isChecked: boolean;
  onChange: (newVal: boolean) => void;
};

const FeedbackFormIsPrivateInput: React.FC<Props> = props => {
  return (
    <FormGroup>
      <Label for="isPrivate">
        <ElementSpacer spacing=".25rem">Private?</ElementSpacer>
      </Label>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Input
          checked={props.isChecked}
          onChange={() => props.onChange(!props.isChecked)}
          translate={{}}
          type="switch"
        />
      </div>
      <FormText>A Private feedback can only be seen by users from your company</FormText>
    </FormGroup>
  );
};

export default FeedbackFormIsPrivateInput;
